'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var localStorage = window.localStorage;

var CURRENCY_OPTIONS = [{ value: 'GBP', label: 'GBP' }, { value: 'EUR', label: 'EUR' }, { value: 'USD', label: 'USD' }];

var SEASONORDER = ['PS', 'SS', 'PA', 'AW'];

var Budget = function (_React$Component) {
	_inherits(Budget, _React$Component);

	function Budget(props) {
		_classCallCheck(this, Budget);

		var _this = _possibleConstructorReturn(this, (Budget.__proto__ || Object.getPrototypeOf(Budget)).call(this, props));

		_this.state = {
			editing: INIT_BUDGET.id === 'new',
			title: INIT_BUDGET.name,
			brand_id: INIT_BUDGET.brand_id,
			season: INIT_BUDGET.season,
			brand_name: INIT_BUDGET.brand_name,
			rows: [].concat(_toConsumableArray(INIT_BUDGET.rows)),
			totals: _this.convertBreakdownToFloats(INIT_BUDGET.currency_breakdown),
			buyingHistory: {},
			lastFourSeasons: _this.lastFourSeasons(INIT_BUDGET.season),
			showErrors: false,
			errorMessages: [],
			hasPreloaded: INIT_BUDGET.id === 'new' ? false : true
		};

		_this.storeSelect = [];

		_this.renderEditor = _this._renderEditor.bind(_this);
		_this.renderMain = _this._renderMain.bind(_this);
		_this.renderIntro = _this._renderIntro.bind(_this);
		_this.renderRow = _this._renderRow.bind(_this);
		_this.renderTotals = _this._renderTotals.bind(_this);
		_this.renderOptions = _this._renderOptions.bind(_this);
		_this.renderBuyingHistory = _this._renderBuyingHistory.bind(_this);
		_this.renderBottomButton = _this._renderBottomButton.bind(_this);
		_this.handleAddRow = _this._handleAddRow.bind(_this);
		_this.handleRemoveRow = _this._handleRemoveRow.bind(_this);
		_this.handleEditRow = _this._handleEditRow.bind(_this);
		_this.handleKeyUp = _this._handleKeyUp.bind(_this);
		_this.handleBrandChange = _this._handleBrandChange.bind(_this);
		_this.handleSeasonChange = _this._handleSeasonChange.bind(_this);
		_this.handleTitleChange = _this._handleTitleChange.bind(_this);
		_this.handlePreload = _this._handlePreload.bind(_this);
		_this.handleSubmit = _this._handleSubmit.bind(_this);
		_this.calcTotals = _underscore2.default.throttle(_this._calcTotals.bind(_this), 2000);
		_this.getBuyingHistory = _this._getBuyingHistory.bind(_this);
		_this.updateBuyingHistory = _this._updateBuyingHistory.bind(_this);
		_this.loadCurrentBuyingHistory = _this._loadCurrentBuyingHistory.bind(_this);
		_this.validate = _this._validate.bind(_this);
		_this.budgetTitlePlaceholder = _this._budgetTitlePlaceholder.bind(_this);
		return _this;
	}

	_createClass(Budget, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (INIT_BUDGET.id !== 'new') {
				this.calcTotals();
				this.loadCurrentBuyingHistory();
				this.lastFourSeasons(INIT_BUDGET.season);
			}
		}
	}, {
		key: 'render',
		value: function render() {

			this.storeSelect = [];

			return _react2.default.createElement(
				'div',
				{ id: 'budget',
					className: (0, _classnames2.default)({ editing: this.state.editing, static: !this.state.editing, showErrors: this.state.showErrors })
				},
				this.renderOptions(),
				this.renderMain(),
				this.renderBottomButton(),
				this.renderTotals()
			);
		}
	}, {
		key: '_renderBottomButton',
		value: function _renderBottomButton() {
			if (!this.state.hasPreloaded) {
				var isPreloadButtonAvailable = this.state.brand_id && this.state.season;

				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)("ix-add rwi-btn-rounded", {
							'rwi-btn-success': isPreloadButtonAvailable,
							'rwi-btn-warning': !isPreloadButtonAvailable
						}), onClick: this.handlePreload },
					'Preload Stores'
				);
			}

			return _react2.default.createElement(
				'div',
				{ className: 'ix-add rwi-btn-rounded rwi-btn-success', onClick: this.handleAddRow },
				'Add Store ',
				_react2.default.createElement('i', { className: 'ri-plus' })
			);
		}
	}, {
		key: '_renderMain',
		value: function _renderMain() {

			if (!this.state.rows.length) {
				return this.renderIntro();
			}

			return this.renderEditor();
		}
	}, {
		key: '_budgetTitlePlaceholder',
		value: function _budgetTitlePlaceholder() {
			var _state = this.state,
			    title = _state.title,
			    brand_name = _state.brand_name,
			    season = _state.season;


			if (title) return title;

			if (brand_name && season) {
				return brand_name + ' – ' + season;
			}

			return 'Budget Title';
		}
	}, {
		key: '_renderOptions',
		value: function _renderOptions() {
			var _state2 = this.state,
			    brand_id = _state2.brand_id,
			    season = _state2.season;


			return _react2.default.createElement(
				'div',
				{ className: 'budget-options' },
				_react2.default.createElement(
					'div',
					{ className: 'info row' },
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('col-sm-4', { error: !brand_id }) },
						_react2.default.createElement(
							'div',
							{ className: 'col-title' },
							'Brand'
						),
						_react2.default.createElement(_reactSelect2.default, {
							options: INIT_BRANDS,
							value: brand_id,
							clearable: false,
							multi: false,
							placeholder: 'Brand',
							onChange: this.handleBrandChange
						})
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('col-sm-4', { error: !season }) },
						_react2.default.createElement(
							'div',
							{ className: 'col-title' },
							'Season'
						),
						_react2.default.createElement(_reactSelect2.default, {
							options: INIT_SEASONS,
							value: season,
							clearable: false,
							multi: false,
							placeholder: 'Season',
							onChange: this.handleSeasonChange
						})
					)
				)
			);
		}
	}, {
		key: '_renderIntro',
		value: function _renderIntro() {

			var step2enabled = this.state.brand_id && this.state.season;

			return _react2.default.createElement(
				'div',
				{ className: 'budget-intro' },
				_react2.default.createElement(
					'h3',
					null,
					'New Budget'
				),
				_react2.default.createElement(
					'ol',
					null,
					_react2.default.createElement(
						'li',
						null,
						'Select a ',
						_react2.default.createElement(
							'strong',
							null,
							'brand'
						),
						' and ',
						_react2.default.createElement(
							'strong',
							null,
							'season'
						),
						' to get started.'
					),
					_react2.default.createElement(
						'li',
						{ className: (0, _classnames2.default)({ faded: !step2enabled }) },
						'Now ',
						_react2.default.createElement(
							'span',
							{ className: 'preload-btn', onClick: this.handlePreload },
							'Preload'
						),
						' a list of stores that have ordered from this brand before.'
					)
				)
			);
		}
	}, {
		key: '_renderEditor',
		value: function _renderEditor() {
			var _state3 = this.state,
			    rows = _state3.rows,
			    brand_id = _state3.brand_id,
			    season = _state3.season;


			return _react2.default.createElement(
				'div',
				{ className: 'editor' },
				_react2.default.createElement(
					'h3',
					null,
					'Stores'
				),
				_react2.default.createElement(
					'div',
					{ className: 'budget-rows' },
					rows.map(this.renderRow)
				)
			);
		}
	}, {
		key: '_renderRow',
		value: function _renderRow(row, i) {
			var _this2 = this;

			var error = !row.store_id || !row.value_foreign;

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("row budget-row", { row_error: error }), key: i },
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('col-sm-3', { error: !row.store_id }) },
					_react2.default.createElement(_reactSelect2.default, {
						onKeyUp: this.handleKeyUp,
						options: INIT_STORES,
						value: row.store_id,
						clearable: false,
						multi: false,
						placeholder: 'Store',
						onChange: this.handleEditRow(i, 'store_id', true),
						ref: function ref(elem) {
							return _this2.storeSelect[i] = elem;
						}
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-2' },
					_react2.default.createElement('input', {
						className: 'currency note',
						onKeyUp: this.handleKeyUp,
						type: 'text',
						placeholder: 'Note',
						value: row.note || '',
						onChange: this.handleEditRow(i, 'note')
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-4 buying-history' },
					this.renderBuyingHistory(row.store_id)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-2' },
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)("currency-wrapper col-sm-6 foreign pull-right", row.currency, { error: !row.value_foreign }) },
							_react2.default.createElement('input', {
								className: 'currency',
								onKeyUp: this.handleKeyUp,
								type: 'text',
								placeholder: 'Value',
								value: row.value_foreign,
								onChange: this.handleEditRow(i, 'value_foreign')
							})
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-sm-6 pull-right budget_currency-selector' },
							_react2.default.createElement(_reactSelect2.default, {
								onKeyUp: this.handleKeyUp,
								options: CURRENCY_OPTIONS,
								value: row.currency || 'GBP',
								multi: false,
								clearable: false,
								placeholder: 'GBP',
								onChange: this.handleEditRow(i, 'currency', true)
							})
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'remove col-sm-1', onClick: this.handleRemoveRow(i) },
					_react2.default.createElement('i', { className: 'ri-minus-o-invert' })
				)
			);
		}
	}, {
		key: 'convertBreakdownToFloats',
		value: function convertBreakdownToFloats(breakdown) {
			return {
				GBP: parseFloat(breakdown.GBP),
				EUR: parseFloat(breakdown.EUR),
				USD: parseFloat(breakdown.USD),
				total: parseFloat(breakdown.total)
			};
		}
	}, {
		key: '_renderTotals',
		value: function _renderTotals() {
			var _state$totals = this.state.totals,
			    GBP = _state$totals.GBP,
			    EUR = _state$totals.EUR,
			    USD = _state$totals.USD,
			    total = _state$totals.total;
			var draftSaved = this.state.draftSaved;


			return _react2.default.createElement(
				'div',
				{ className: 'totals' },
				_react2.default.createElement(
					'div',
					{ className: 'rwi-container' },
					_react2.default.createElement(
						'div',
						{ className: 'error-messages' },
						this.state.errorMessages.map(function (message) {
							return _react2.default.createElement(
								'li',
								{ key: message },
								message
							);
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'pull-right ix-save ix', onClick: this.handleSubmit },
						'Submit'
					),
					_react2.default.createElement(
						'div',
						{ className: 'title' },
						'Totals'
					),
					_react2.default.createElement(
						'div',
						{ className: 'total-currency' },
						_react2.default.createElement(
							'div',
							{ className: 'cur' },
							'GBP'
						),
						_react2.default.createElement(
							'div',
							{ className: 'value' },
							'\xA3',
							this.formatCurrency(GBP, 'GBP')
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'total-currency' },
						_react2.default.createElement(
							'div',
							{ className: 'cur' },
							'EUR'
						),
						_react2.default.createElement(
							'div',
							{ className: 'value' },
							'\u20AC',
							this.formatCurrency(EUR, 'EUR')
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'total-currency' },
						_react2.default.createElement(
							'div',
							{ className: 'cur' },
							'USD'
						),
						_react2.default.createElement(
							'div',
							{ className: 'value' },
							'$',
							this.formatCurrency(USD, 'USD')
						)
					)
				)
			);
		}
	}, {
		key: '_renderBuyingHistory',
		value: function _renderBuyingHistory(store_id) {
			var _this3 = this;

			if (!store_id) return null;

			var _state4 = this.state,
			    lastFourSeasons = _state4.lastFourSeasons,
			    buyingHistory = _state4.buyingHistory;


			return lastFourSeasons.map(function (season, i) {

				var seasonValue = '',
				    seasonValueForeign = '';

				if (buyingHistory[store_id] && buyingHistory[store_id][season]) {

					seasonValue = '£' + _this3.formatCurrency(buyingHistory[store_id][season].GBP);

					if (buyingHistory[store_id][season].currency !== 'GBP') {
						seasonValueForeign = (buyingHistory[store_id][season].currency === 'EUR' ? '€' : '$') + _this3.formatCurrency(buyingHistory[store_id][season][buyingHistory[store_id][season].currency]);
					}
				}

				return _react2.default.createElement(
					'div',
					{ className: 'season', key: season },
					_react2.default.createElement(
						'div',
						{ className: 'title' },
						season
					),
					_react2.default.createElement(
						'div',
						{ className: 'value' },
						seasonValue
					),
					_react2.default.createElement(
						'div',
						{ className: 'value valueForeign' },
						seasonValueForeign
					)
				);
			});
		}
	}, {
		key: '_handleKeyUp',
		value: function _handleKeyUp(e) {
			if (e.keyCode == 13) {
				this.handleAddRow();
			}
		}
	}, {
		key: '_handleEditRow',
		value: function _handleEditRow(i, field, selectField, numeric) {
			var _this4 = this;

			return function (e) {
				var row = _extends({}, _this4.state.rows[i]);
				row[field] = selectField ? e.value : e.target.value;
				if (field !== 'currency' && field !== 'note' && isNaN(row[field])) {
					return;
				}
				_this4.setState({
					rows: [].concat(_toConsumableArray(_this4.state.rows.slice(0, i)), [row], _toConsumableArray(_this4.state.rows.slice(i + 1)))
				}, function () {
					if (field == 'store_id') {
						if (!_this4.state.buyingHistory[e.value]) {
							_this4.getBuyingHistory([e.value]);
						}
					} else if (field == 'note') {
						// nothing
					} else {
						_this4.calcTotals();
					}
				});
			};
		}
	}, {
		key: '_handleRemoveRow',
		value: function _handleRemoveRow(i) {
			var _this5 = this;

			return function () {
				_this5.setState({
					rows: [].concat(_toConsumableArray(_this5.state.rows.slice(0, i)), _toConsumableArray(_this5.state.rows.slice(i + 1)))
				}, function () {
					_this5.calcTotals();
				});
			};
		}
	}, {
		key: '_handleAddRow',
		value: function _handleAddRow() {
			var _this6 = this;

			// return if brand and season is not set. 
			if (!this.state.brand_id || !this.state.season) {
				return;
			}

			// return if last row does not have store selected
			if (this.state.rows.length && !this.state.rows[this.state.rows.length - 1].store_id) {
				this.storeSelect[this.state.rows.length - 1].focus();
				return false;
			}

			this.setState({
				rows: [].concat(_toConsumableArray(this.state.rows), [{
					store_id: '',
					currency: '',
					value: '',
					value_foreign: ''
				}])
			}, function () {
				_this6.storeSelect[_this6.state.rows.length - 1].focus();
			});
		}
	}, {
		key: '_handleBrandChange',
		value: function _handleBrandChange(brand) {
			var _this7 = this;

			this.setState({
				brand_id: brand.value,
				brand_name: brand.label,
				buyingHistory: {}
			}, function () {
				_this7.loadCurrentBuyingHistory();
			});
		}
	}, {
		key: '_handleSeasonChange',
		value: function _handleSeasonChange(season) {

			this.setState({
				season: season.value,
				lastFourSeasons: this.lastFourSeasons(season.value)
			});
		}
	}, {
		key: '_handleTitleChange',
		value: function _handleTitleChange(e) {
			this.setState({
				title: e.target.value
			});
		}
	}, {
		key: '_handlePreload',
		value: function _handlePreload() {
			var _this8 = this;

			if (!this.state.brand_id) return;

			var data = {
				brand_id: this.state.brand_id
			};

			_request2.default.get({
				url: location.origin + '/ajax/budgets/lastOrdersStores',
				qs: data
			}, function (err, httpResponse, body) {

				_this8.setState({
					hasPreloaded: true
				});

				if (err) {
					console.error(err);
					return;
				}
				var data = JSON.parse(body);

				_this8.setState({
					rows: data
				}, function () {
					_this8.loadCurrentBuyingHistory();
				});
			});
		}
	}, {
		key: '_handleSubmit',
		value: function _handleSubmit() {

			var errors = this.validate();
			if (errors.length) {
				this.setState({
					showErrors: true,
					errorMessages: errors
				});
				return;
			}

			var _state5 = this.state,
			    brand_id = _state5.brand_id,
			    rows = _state5.rows,
			    season = _state5.season;


			var items = rows.map(function (_ref) {
				var store_id = _ref.store_id,
				    currency = _ref.currency,
				    value = _ref.value,
				    value_foreign = _ref.value_foreign,
				    note = _ref.note;
				return {
					store_id: store_id,
					currency: currency,
					value: value,
					value_foreign: value_foreign,
					note: note
				};
			});

			var data = {
				title: this.budgetTitlePlaceholder(),
				brand_id: brand_id,
				season: season,
				items: items
			};

			var headers = new Headers();
			headers.append('Content-Type', 'application/json');
			// headers.append('X-CSRF-TOKEN', CSRF_TOKEN);
			var url = '/ajax/budgets/' + INIT_BUDGET.id;
			var request = new Request(url, {
				credentials: 'same-origin',
				headers: headers,
				method: 'POST',
				body: JSON.stringify(data)
			});

			fetch(request).then(function (response) {
				return response.json();
			}).then(function (response) {
				localStorage.removeItem('rwi__budget_draft');
				location.href = '/data/budgets/' + response.id;
			}).catch(function (e) {
				return console.log(e);
			});
		}
	}, {
		key: '_calcTotals',
		value: function _calcTotals() {
			var rows = this.state.rows;

			var totals = {
				GBP: 0,
				EUR: 0,
				USD: 0,
				total: 0
			};

			for (var i = 0; i < rows.length; i++) {
				var currency = rows[i].currency || 'GBP';
				totals[currency] += parseFloat(rows[i].value_foreign) || 0;
				totals.total += parseFloat(rows[i].value) || 0;
			}

			this.setState({
				totals: totals
			});
		}
	}, {
		key: 'formatCurrency',
		value: function formatCurrency(value, currency) {

			return new Intl.NumberFormat('en-GB', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(value);
		}
	}, {
		key: '_loadCurrentBuyingHistory',
		value: function _loadCurrentBuyingHistory() {
			var this$1 = this;

			var ids = [];
			for (var i = 0; i < this.state.rows.length; i++) {
				ids.push(this$1.state.rows[i].store_id);
			}
			this.getBuyingHistory(ids);
		}
	}, {
		key: '_getBuyingHistory',
		value: function _getBuyingHistory(ids) {
			var _this9 = this;

			if (!ids || !ids.length || !this.state.brand_id) return;

			if (!Array.isArray(ids)) {
				ids = [ids];
			}

			var data = {
				store_ids: ids,
				brand_id: this.state.brand_id
			};

			_request2.default.get({
				url: location.origin + '/ajax/budgets/storeBuying',
				qs: data
			}, function (err, httpResponse, body) {
				if (err) {
					console.error(err);
					return;
				}
				var data = JSON.parse(body);
				_this9.updateBuyingHistory(data);
			});
		}
	}, {
		key: '_updateBuyingHistory',
		value: function _updateBuyingHistory(data) {
			var history = _extends({}, this.state.buyingHistory);
			var keys = Object.keys(data);
			for (var i = keys.length - 1; i >= 0; i--) {
				history[keys[i]] = data[keys[i]];
			}

			this.setState({
				buyingHistory: history
			});
		}
	}, {
		key: 'lastFourSeasons',
		value: function lastFourSeasons(season) {

			if (!season) return [];

			var seasonName = season.substring(0, 2);
			var seasonYear = parseInt(season.substring(2, 4), 10);
			var seasonIndex = SEASONORDER.indexOf(seasonName);

			var seasons = [],
			    newSeasonName,
			    newSeasonYear,
			    newIndex;

			for (var i = 1; i < 5; i++) {

				newIndex = seasonIndex - i;
				if (newIndex < 0) {
					newIndex = SEASONORDER.length + newIndex;
					newSeasonYear = seasonYear - 1;
				} else {
					newSeasonYear = seasonYear;
				}
				newSeasonName = SEASONORDER[newIndex];

				seasons.push(newSeasonName + newSeasonYear);
			}

			seasons.reverse();

			return seasons;
		}
	}, {
		key: '_validate',
		value: function _validate() {
			var _state6 = this.state,
			    brand_id = _state6.brand_id,
			    season = _state6.season,
			    rows = _state6.rows;

			var errors = [];

			if (!brand_id) {
				errors.push("Please select a brand.");
			}

			if (!season) {
				errors.push("Please select a season.");
			}

			if (!rows.length) {
				errors.push("Please add a few stores.");
			}

			for (var i = 0; i < rows.length; i++) {
				var _rows$i = rows[i],
				    store_id = _rows$i.store_id,
				    value_foreign = _rows$i.value_foreign;


				if (!store_id && !value_foreign) continue;

				if (!store_id) {
					var message = "Please select a store for each row.";
					if (errors.indexOf(message) === -1) {
						errors.push(message);
					}
				}
			}

			return errors;
		}
	}]);

	return Budget;
}(_react2.default.Component);

exports.default = Budget;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/data/Budget.js
// module id = 512
// module chunks = 0